// hooks/useSyncLanguageUrl.js
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export function useSyncLanguageUrl(pageLanguage) {
  const location = useLocation();

  useEffect(() => {
    if (!pageLanguage) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('plang', pageLanguage);

    const newRelativePathQuery =
      location.pathname + '?' + searchParams.toString();
    window.history.replaceState(null, '', newRelativePathQuery);
  }, [pageLanguage, location.pathname, location.search]);
}
